const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'Привет',
    'Ref: Page content body':
      'По прибытии и вылете, пожалуйста, не забудьте сканировать автобус QR -кода',
  },
};
export default labels;
